export default __webpack_public_path__ + "static/media/collapse.94255157.svg";